import { resourceState, resourceMutations } from '@/store/utils/resource';
import { notificationSettingsClient as client } from '@/api/clients';
import { NOTIFICATION_SETTINGS } from '@/store/entities/schema_types';

export default {
  namespaced: true,

  state: resourceState(),

  mutations: resourceMutations,

  getters: {
    notificationSettings(state, _, rootState) {
      return state.ids.map((id) => rootState.entities.notificationSettings.byId[id]);
    },
  },

  actions: {
    async load(ctx, { params = {} } = {}) {
      try {
        const response = await client.list({ params });
        const { data: payload } = response;
        const { data, meta, links } = payload;

        const taskUuids = await ctx.dispatch(
          'entities/persistEntities',
          { type: NOTIFICATION_SETTINGS, data },
          { root: true }
        );

        ctx.commit('setIds', taskUuids);
        ctx.commit('setMeta', meta);
        ctx.commit('setLinks', links);

        return Promise.resolve(true);
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
